import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Dropdown, Badge, Typography } from 'antd';
import { BellOutlined, MailOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import commonService from '../../services/CommonService';
import { setCertExpInSixMonthCount, setCertRenewalReminderCount, setFactoryAuditNotifyCount, setLastTwoMonthUpdRegCount, setReqUpdLastTwoMonthCount, setVendorPortalNotificationList } from '../../context/reducers/userReducer';
const Notifications = () => {
    var _a, _b, _c, _d;
    const [notificationCount, setNotificationCount] = useState(0);
    const [factoryAuditNotifyCount, setFactoryAuditNotifyCounts] = useState();
    const [certExpInSixMonthCount, setCertExpInSixMonthCounts] = useState();
    const [certRenewalReminderCount, setCertRenewalReminderCounts] = useState();
    const [lastTwoMonthUpdRegCount, setLastTwoMonthUpdRegCounts] = useState();
    const [reqUpdLastTwoMonthCount, setReqUpdLastTwoMonthCounts] = useState();
    const [intTotalCertCount, setIntTotalCertCounts] = useState(0);
    const [intTotalFACount, setIntTotalFACount] = useState(0);
    const [vendorNotificationObjs, setVendorNotificationObjs] = useState();
    const [intTotalVendorCount, setIntTotalVendorCount] = useState(0);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [lstVendorNewAssignments, setLstVendorNewAssignments] = useState([]);
    const [lstVendorNewStatusChange, setLstVendorNewStatusChange] = useState([]);
    const [lstVendorNewDocumentUpload, setLstVendorNewDocumentUpload] = useState([]);
    const applicationData = useSelector((state) => state.applicationData); //useApplicationContext();
    let isVendorLogin = (applicationData === null || applicationData === void 0 ? void 0 : applicationData.userRole) == 2 ? true : false;
    let inputData = [{
            intId: (_b = (_a = applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID,
            strLoggedInUser: (_d = (_c = applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId
        }];
    const updateData = () => {
        var _a, _b;
        if (!isVendorLogin) {
            commonService.getAllNotificationsCount(inputData, 'getAllFANotificationsCount').then((res) => {
                dispatch(setFactoryAuditNotifyCount(res));
            });
            commonService.getAllNotificationsCount(inputData, 'getCertExpInSixMonthCount').then((res) => {
                dispatch(setCertExpInSixMonthCount(res));
            });
            commonService.getAllNotificationsCount(inputData, 'getCertRenewalReminderCount').then((res) => dispatch(setCertRenewalReminderCount(res)));
            commonService.getAllNotificationsCount(inputData, 'getLastTwoMonthUpdRegCount').then((res) => dispatch(setLastTwoMonthUpdRegCount(res)));
            commonService.getAllNotificationsCount(inputData, 'getReqUpdLastTwoMonthCount').then((res) => dispatch(setReqUpdLastTwoMonthCount(res)));
        }
        else {
            commonService.getVendorPortalNotificationList((_b = (_a = applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID).then((res) => {
                dispatch(setVendorPortalNotificationList(res));
            });
        }
    };
    useEffect(() => {
        var _a, _b, _c, _d;
        setFactoryAuditNotifyCounts(applicationData === null || applicationData === void 0 ? void 0 : applicationData.factoryAuditNotifyCount);
        setCertExpInSixMonthCounts(applicationData === null || applicationData === void 0 ? void 0 : applicationData.certExpInSixMonthCount);
        setCertRenewalReminderCounts(applicationData === null || applicationData === void 0 ? void 0 : applicationData.certRenewalReminderCount);
        setLastTwoMonthUpdRegCounts(applicationData === null || applicationData === void 0 ? void 0 : applicationData.lastTwoMonthUpdRegCount);
        setReqUpdLastTwoMonthCounts(applicationData === null || applicationData === void 0 ? void 0 : applicationData.reqUpdLastTwoMonthCount);
        let lstVendorNewAssignments = [];
        let lstVendorNewStatusChange = [];
        let lstVendorNewDocumentUpload = [];
        (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.vendorPortalNotificationList) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
            if ((item === null || item === void 0 ? void 0 : item.intId) == 100) {
                let decodedVal = btoa(item === null || item === void 0 ? void 0 : item.strLongDesc);
                lstVendorNewAssignments.push(Object.assign(Object.assign({}, item), { strShortDesc: decodedVal, key: decodedVal }));
            }
            if ((item === null || item === void 0 ? void 0 : item.intId) == 101) {
                let decodedVal = btoa(item === null || item === void 0 ? void 0 : item.strLongDesc);
                lstVendorNewStatusChange.push(Object.assign(Object.assign({}, item), { strShortDesc: decodedVal, key: decodedVal }));
            }
            if ((item === null || item === void 0 ? void 0 : item.intId) == 102) {
                let decodedVal = btoa(item === null || item === void 0 ? void 0 : item.strLongDesc);
                lstVendorNewDocumentUpload.push(Object.assign(Object.assign({}, item), { strShortDesc: decodedVal, key: decodedVal }));
            }
        });
        setLstVendorNewAssignments(lstVendorNewAssignments);
        setLstVendorNewStatusChange(lstVendorNewStatusChange);
        setLstVendorNewDocumentUpload(lstVendorNewDocumentUpload);
        setVendorNotificationObjs({
            lstVendorNewAssignments: lstVendorNewAssignments,
            lstVendorNewStatusChange: lstVendorNewStatusChange,
            lstVendorNewDocumentUpload: lstVendorNewDocumentUpload
        });
        setIntTotalVendorCount(((_b = vendorNotificationObjs === null || vendorNotificationObjs === void 0 ? void 0 : vendorNotificationObjs.lstVendorNewAssignments) === null || _b === void 0 ? void 0 : _b.length) + ((_c = vendorNotificationObjs === null || vendorNotificationObjs === void 0 ? void 0 : vendorNotificationObjs.lstVendorNewStatusChange) === null || _c === void 0 ? void 0 : _c.length) + ((_d = vendorNotificationObjs === null || vendorNotificationObjs === void 0 ? void 0 : vendorNotificationObjs.lstVendorNewDocumentUpload) === null || _d === void 0 ? void 0 : _d.length));
    }, [applicationData === null || applicationData === void 0 ? void 0 : applicationData.factoryAuditNotifyCount, applicationData === null || applicationData === void 0 ? void 0 : applicationData.certExpInSixMonthCount, applicationData === null || applicationData === void 0 ? void 0 : applicationData.certRenewalReminderCount, applicationData === null || applicationData === void 0 ? void 0 : applicationData.lastTwoMonthUpdRegCount, applicationData === null || applicationData === void 0 ? void 0 : applicationData.reqUpdLastTwoMonthCount, applicationData === null || applicationData === void 0 ? void 0 : applicationData.vendorPortalNotificationList]);
    useEffect(() => {
        var _a, _b, _c;
        setIntTotalFACount((factoryAuditNotifyCount === null || factoryAuditNotifyCount === void 0 ? void 0 : factoryAuditNotifyCount.intTotalCount) || 0);
        let intCertCount = ((certExpInSixMonthCount === null || certExpInSixMonthCount === void 0 ? void 0 : certExpInSixMonthCount.intStatusCount) || 0) +
            ((certRenewalReminderCount === null || certRenewalReminderCount === void 0 ? void 0 : certRenewalReminderCount.intStatusCount) || 0) +
            ((lastTwoMonthUpdRegCount === null || lastTwoMonthUpdRegCount === void 0 ? void 0 : lastTwoMonthUpdRegCount.intStatusCount) || 0) +
            ((reqUpdLastTwoMonthCount === null || reqUpdLastTwoMonthCount === void 0 ? void 0 : reqUpdLastTwoMonthCount.intStatusCount) || 0);
        setIntTotalCertCounts(intCertCount);
        setNotificationCount(intCertCount + intTotalFACount);
        setIntTotalVendorCount(((_a = vendorNotificationObjs === null || vendorNotificationObjs === void 0 ? void 0 : vendorNotificationObjs.lstVendorNewAssignments) === null || _a === void 0 ? void 0 : _a.length) + ((_b = vendorNotificationObjs === null || vendorNotificationObjs === void 0 ? void 0 : vendorNotificationObjs.lstVendorNewStatusChange) === null || _b === void 0 ? void 0 : _b.length) + ((_c = vendorNotificationObjs === null || vendorNotificationObjs === void 0 ? void 0 : vendorNotificationObjs.lstVendorNewDocumentUpload) === null || _c === void 0 ? void 0 : _c.length));
    }, [
        factoryAuditNotifyCount,
        certExpInSixMonthCount,
        certRenewalReminderCount,
        lastTwoMonthUpdRegCount,
        reqUpdLastTwoMonthCount,
        vendorNotificationObjs
    ]);
    const handleMenuClick = (key) => {
        let keys = ["EXPSIXMONTH", "CERTWITHUPDREG", "RENEWALOVERDUE", "CERTWITHUPDREQ"];
        let keysFactoryAudit = ["TODAY", "NEXT30", "THISWEEK", "LASTWEEK", "LASTTWOWEEKS", "LASTTHREEWEEKS",
            "SHOWALL"];
        if (keysFactoryAudit.includes(key))
            navigate('/factory-audit-notifications', { state: { keyValue: key, data: factoryAuditNotifyCount } });
        else if (keys.includes(key)) {
            const url = `/certificates?n_code=${key}`;
            if (window.location.pathname + window.location.search === url) {
                window.location.reload(); // Reload the page
            }
            else {
                window.location.href = url; // Navigate to the URL if it's not the current one
            }
        }
    };
    // const notificationMenu = (
    //   <Menu mode='inline' 
    //     onClick={({ key }) => handleMenuClick(key)}>
    //     {!isVendorLogin && (<>
    //       {intTotalFACount !== 0 ?  
    //       <SubMenu key="sub1" title="Factory Audit" icon={<MailOutlined />}>
    //         <Menu.Item key="TODAY">Expiring Today - {factoryAuditNotifyCount?.intTodayCount}</Menu.Item>
    //         <Menu.Item key="NEXT30">Expiring in Next 30 Days - {factoryAuditNotifyCount?.intNext30DaysCount}</Menu.Item>
    //         <Menu.Item key="THISWEEK">Expired This Week - {factoryAuditNotifyCount?.intThisWeekCount}</Menu.Item>
    //         <Menu.Item key="LASTWEEK">Expired Last Week - {factoryAuditNotifyCount?.intLastWeekCount}</Menu.Item>
    //         <Menu.Item key="LASTTWOWEEKS">Expired Two Weeks Ago - {factoryAuditNotifyCount?.intTwoWeeksAgoCount}</Menu.Item>
    //         <Menu.Item key="LASTTHREEWEEKS">Expired Three Weeks Ago - {factoryAuditNotifyCount?.intThreeWeeksAgoCount}</Menu.Item>
    //         <Menu.Item key="SHOWALL"> <b>Show All </b></Menu.Item>
    //       </SubMenu>
    //      : null 
    //     }
    //   {intTotalCertCount !== 0 ?  
    //       <SubMenu key="sub2" title="Certificates" icon={<SafetyCertificateOutlined />} >
    //         <Menu.Item key="EXPSIXMONTH">{certExpInSixMonthCount?.strLongDesc} - {certExpInSixMonthCount?.intStatusCount}</Menu.Item>
    //         <Menu.Item key="CERTWITHUPDREG">{lastTwoMonthUpdRegCount?.strLongDesc} - {lastTwoMonthUpdRegCount?.intStatusCount}</Menu.Item>
    //         <Menu.Item key="RENEWALOVERDUE">{certRenewalReminderCount?.strLongDesc} - {certRenewalReminderCount?.intStatusCount}</Menu.Item>
    //         <Menu.Item key="CERTWITHUPDREQ">{reqUpdLastTwoMonthCount?.strLongDesc} - {reqUpdLastTwoMonthCount?.intStatusCount}</Menu.Item>
    //       </SubMenu>
    //       : null 
    //     }
    //       </>
    //     )}
    //     {isVendorLogin && (
    //       // <Menu.Item key="VENDOR_NOTIFICATIONS">
    //         <VendorNotifications data={vendorNotificationObjs} />
    //       // </Menu.Item>
    //     )}
    //   </Menu>
    // );
    const items = [];
    if (!isVendorLogin) {
        if (intTotalFACount !== 0) {
            items.push({
                key: 'sub1',
                label: 'Factory Audit',
                icon: _jsx(MailOutlined, {}),
                children: [
                    {
                        key: 'TODAY',
                        label: `Expiring Today - ${factoryAuditNotifyCount === null || factoryAuditNotifyCount === void 0 ? void 0 : factoryAuditNotifyCount.intTodayCount}`,
                        onClick: () => handleMenuClick('TODAY'),
                    },
                    {
                        key: 'NEXT30',
                        label: `Expiring in Next 30 Days - ${factoryAuditNotifyCount === null || factoryAuditNotifyCount === void 0 ? void 0 : factoryAuditNotifyCount.intNext30DaysCount}`,
                        onClick: () => handleMenuClick('NEXT30'),
                    },
                    {
                        key: 'THISWEEK',
                        label: `Expired This Week - ${factoryAuditNotifyCount === null || factoryAuditNotifyCount === void 0 ? void 0 : factoryAuditNotifyCount.intThisWeekCount}`,
                        onClick: () => handleMenuClick('THISWEEK'),
                    },
                    {
                        key: 'LASTWEEK',
                        label: `Expired Last Week - ${factoryAuditNotifyCount === null || factoryAuditNotifyCount === void 0 ? void 0 : factoryAuditNotifyCount.intLastWeekCount}`,
                        onClick: () => handleMenuClick('LASTWEEK'),
                    },
                    {
                        key: 'LASTTWOWEEKS',
                        label: `Expired Two Weeks Ago - ${factoryAuditNotifyCount === null || factoryAuditNotifyCount === void 0 ? void 0 : factoryAuditNotifyCount.intTwoWeeksAgoCount}`,
                        onClick: () => handleMenuClick('LASTTWOWEEKS'),
                    },
                    {
                        key: 'LASTTHREEWEEKS',
                        label: `Expired Three Weeks Ago - ${factoryAuditNotifyCount === null || factoryAuditNotifyCount === void 0 ? void 0 : factoryAuditNotifyCount.intThreeWeeksAgoCount}`,
                        onClick: () => handleMenuClick('LASTTHREEWEEKS'),
                    },
                    {
                        key: 'SHOWALL',
                        label: _jsx("b", { children: "Show All" }),
                        onClick: () => handleMenuClick('SHOWALL'),
                    },
                ],
                disabled: intTotalFACount === 0,
            });
        }
        if (intTotalCertCount !== 0) {
            items.push({
                key: 'sub2',
                label: 'Certificates',
                icon: _jsx(SafetyCertificateOutlined, {}),
                children: [
                    {
                        key: 'EXPSIXMONTH',
                        label: `${certExpInSixMonthCount === null || certExpInSixMonthCount === void 0 ? void 0 : certExpInSixMonthCount.strLongDesc} - ${certExpInSixMonthCount === null || certExpInSixMonthCount === void 0 ? void 0 : certExpInSixMonthCount.intStatusCount}`,
                        onClick: () => handleMenuClick('EXPSIXMONTH'),
                    },
                    {
                        key: 'CERTWITHUPDREG',
                        label: `${lastTwoMonthUpdRegCount === null || lastTwoMonthUpdRegCount === void 0 ? void 0 : lastTwoMonthUpdRegCount.strLongDesc} - ${lastTwoMonthUpdRegCount === null || lastTwoMonthUpdRegCount === void 0 ? void 0 : lastTwoMonthUpdRegCount.intStatusCount}`,
                        onClick: () => handleMenuClick('CERTWITHUPDREG'),
                    },
                    {
                        key: 'RENEWALOVERDUE',
                        label: `${certRenewalReminderCount === null || certRenewalReminderCount === void 0 ? void 0 : certRenewalReminderCount.strLongDesc} - ${certRenewalReminderCount === null || certRenewalReminderCount === void 0 ? void 0 : certRenewalReminderCount.intStatusCount}`,
                        onClick: () => handleMenuClick('RENEWALOVERDUE'),
                    },
                    {
                        key: 'CERTWITHUPDREQ',
                        label: `${reqUpdLastTwoMonthCount === null || reqUpdLastTwoMonthCount === void 0 ? void 0 : reqUpdLastTwoMonthCount.strLongDesc} - ${reqUpdLastTwoMonthCount === null || reqUpdLastTwoMonthCount === void 0 ? void 0 : reqUpdLastTwoMonthCount.intStatusCount}`,
                        onClick: () => handleMenuClick('CERTWITHUPDREQ'),
                    },
                ],
                disabled: intTotalCertCount === 0,
            });
        }
    }
    if (isVendorLogin) {
        const itemsNewAss = [];
        lstVendorNewAssignments === null || lstVendorNewAssignments === void 0 ? void 0 : lstVendorNewAssignments.map((item) => {
            itemsNewAss.push({
                key: item.strShortDesc,
                label: item.strLongDesc,
                onClick: () => navigate(`vendor/sub-project-detail/${item.strShortDesc}`),
                style: { color: 'blue' },
            });
        });
        const itemsNewStatus = [];
        lstVendorNewStatusChange === null || lstVendorNewStatusChange === void 0 ? void 0 : lstVendorNewStatusChange.map((item) => {
            itemsNewStatus.push({
                key: item.strShortDesc,
                label: item.strLongDesc,
                onClick: () => navigate(`vendor/sub-project-detail/${item.strShortDesc}`),
                style: { color: 'blue' },
            });
        });
        const itemsNewDocs = [];
        lstVendorNewDocumentUpload === null || lstVendorNewDocumentUpload === void 0 ? void 0 : lstVendorNewDocumentUpload.map((item) => {
            itemsNewDocs.push({
                key: item.strShortDesc,
                label: item.strLongDesc,
                onClick: () => navigate(`vendor/sub-project-detail/${item.strShortDesc}`),
                style: { color: 'blue' },
            });
        });
        items.push({
            key: '1',
            label: _jsxs(Typography.Text, { children: ["You have ", lstVendorNewAssignments === null || lstVendorNewAssignments === void 0 ? void 0 : lstVendorNewAssignments.length, " new assignments"] }),
            children: (itemsNewAss === null || itemsNewAss === void 0 ? void 0 : itemsNewAss.length) !== 0 ? itemsNewAss : undefined,
        }, {
            key: '2',
            label: _jsxs(Typography.Text, { children: ["Sub Project Status updated for below (", lstVendorNewStatusChange === null || lstVendorNewStatusChange === void 0 ? void 0 : lstVendorNewStatusChange.length, ")"] }),
            children: (itemsNewStatus === null || itemsNewStatus === void 0 ? void 0 : itemsNewStatus.length) !== 0 ? itemsNewStatus : undefined,
        }, {
            key: '3',
            label: _jsxs(Typography.Text, { children: ["New Documents Uploaded for below (", lstVendorNewDocumentUpload === null || lstVendorNewDocumentUpload === void 0 ? void 0 : lstVendorNewDocumentUpload.length, ")"] }),
            children: (itemsNewDocs === null || itemsNewDocs === void 0 ? void 0 : itemsNewDocs.length) !== 0 ? itemsNewDocs : undefined,
        });
    }
    return (_jsx(Dropdown, { menu: { items }, trigger: ['click'], placement: "bottomRight", children: _jsx("span", { onClick: () => updateData(), style: { cursor: 'pointer', marginTop: '0px', }, children: _jsx(Badge, { count: !isVendorLogin ? notificationCount : intTotalVendorCount, size: 'small', offset: [!isVendorLogin ? (notificationCount > 10 ? 10 : 0) : (intTotalVendorCount > 10 ? 10 : 0), 0], color: '#00A4A4', children: _jsx(BellOutlined, { style: {
                        color: '#fff',
                        fontSize: 'large',
                        cursor: 'pointer',
                    } }) }) }) }));
};
export default Notifications;
